import React, { Component } from 'react';
import './LineGraph.css';
import { d3 } from 'react-d3-components';

class LineGraph extends Component {
  componentDidMount() {
    this.buildGraph();
  }

  componentWillReceiveProps(props) {
    this.updateGraph(props.data);
  }

  buildGraph() {
    const {
      data = [],
      width = this.lineGraphSpace.offsetWidth,
      height = 300,
      yAxisTitle,
      colorLine,
      textLine,
      xAt0 = false,
      linearScale = false,
    } = this.props;
    // console.log(data);

    const margin = {
      bottom: 80,
      left: 60,
      right: 80,
      top: 40,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const x = linearScale ? d3.scale.linear() : d3.time.scale();
    x.range([30, chartWidth]);

    let xMin = d3.min(data, d => d.x);
    let xMax = d3.max(data, d => d.x);
    // console.log(xMin);
    // console.log(xMax);

    if (xMin === xMax) {
      xMax *= 2;
      xMin = 0;
    }

    x.domain([
      xMin,
      xMax]);

    const minValue = d3.min(data, d => d.y);
    const maxValue = d3.max(data, d => d.y);

    // console.log(minValue);
    // console.log(maxValue);

    const y = d3.scale.linear()
      .range([chartHeight, 0]);
    if (xAt0) {
      y.domain([
        minValue > 0 ? 0 : minValue,
        maxValue < 0 ? 0 : maxValue]);
    } else if (minValue === maxValue) {
      y.domain([
        minValue - 1,
        maxValue + 1]);
    } else {
      y.domain([
        minValue,
        maxValue]);
    }


    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10);
    // console.log(linearScale);
    if (! linearScale) xAxis.tickFormat(d3.time.format('%b %d, %Y %H:%M'));

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    const svg = d3.select(this.lineGraphSpace).append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    this.setState({
      svg,
    }, () => {
      this.addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, yAxisTitle);
      this.drawPaths(x, y, data, colorLine);
      this.appendLegend(chartWidth, colorLine, textLine);
    });
  }

  addAxes(xAxis, yAxis, margin, chartWidth, chartHeight, yAxisTitle) {
    const { svg } = this.state;

    const axes = svg.append('g')
      .attr('class', 'axies');

    axes.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0,${chartHeight})`)
      .call(xAxis)
      .selectAll('text')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start')
      .append('text')
      .attr('y', -6)
      .attr('x', chartWidth)
      .style('text-anchor', 'middle')
      .text('Time');

    axes.append('g')
      .attr('class', 'y axis')
      .attr('transform', 'translate(30,0)')
      .call(yAxis)
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', -75)
      .attr('dy', '.71em')
      .style('text-anchor', 'end')
      .text(yAxisTitle);
  }

  drawPaths(x, y, data, colorLine) {
    const { svg } = this.state;

    const line1 = d3.svg.line()
      .x(d => x(d.x))
      .y(d => y(d.y));

    const graph = svg.append('g')
      .attr('class', 'graph');

    graph.datum(data);

    graph.append('path')
      .attr('class', 'line')
      .attr('stroke', colorLine)
      .attr('d', line1);
  }

  appendLegend(chartWidth, colorLine, textLine) {
    const { svg } = this.state;
    const legend = svg.append('g')
      .attr('class', 'chartLegend');

    const singleLegend = legend.append('g')
      .attr('class', 'singleLegend');

    singleLegend.append('circle')
      .attr('r', 5)
      .style('fill', colorLine)
      .style('stroke', colorLine);

    singleLegend.append('text')
      .text(textLine)
      .attr('dy', '.32em')
      .attr('dx', '9');

    legend.attr('transform', `translate(${chartWidth - legend.select('.singleLegend').node().getBBox().width}, -20)`);
  }

  updateGraph(data) {
    const {
      width = this.lineGraphSpace.offsetWidth,
      height = 300,
      xAt0 = false,
      linearScale = false,
    } = this.props;

    const margin = {
      bottom: 80,
      left: 60,
      right: 40,
      top: 40,
    };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const x = linearScale ? d3.scale.linear() : d3.time.scale();
    x.range([30, chartWidth]);

    let xMin = d3.min(data, d => d.x);
    let xMax = d3.max(data, d => d.x);
    // console.log(xMin);
    // console.log(xMax);

    if (xMin === xMax) {
      xMax *= 2;
      xMin = 0;
    }

    x.domain([
      xMin,
      xMax]);

    const minValue = d3.min(data, d => d.y);
    const maxValue = d3.max(data, d => d.y);
    // console.log(minValue);
    // console.log(maxValue);
    const y = d3.scale.linear()
      .range([chartHeight, 0]);

    if (xAt0) {
      y.domain([
        minValue > 0 ? 0 : minValue,
        maxValue < 0 ? 0 : maxValue]);
    } else if (minValue === maxValue) {
      y.domain([
        minValue - 1,
        maxValue + 1]);
    } else {
      y.domain([
        minValue,
        maxValue]);
    }

    const xAxis = d3.svg.axis().scale(x).orient('bottom')
      .innerTickSize(-chartHeight)
      .outerTickSize(0)
      .tickPadding(10);

    if (! linearScale) xAxis.tickFormat(d3.time.format('%b %d, %Y %H:%M'));

    const yAxis = d3.svg.axis().scale(y).orient('left')
      .innerTickSize(-chartWidth)
      .outerTickSize(0)
      .tickPadding(10);

    this.updatePaths(x, y, data);
    this.updateAxes(xAxis, yAxis);
  }

  updatePaths(x, y, data) {
    const { svg } = this.state;

    const line1 = d3.svg.line()
      .x(d => x(d.x))
      .y(d => y(d.y));
    const graph = svg.select('g.graph')
      .attr('class', 'graph');

    graph.datum(data);

    graph.select('.line')
      .attr('d', line1);
  }

  updateAxes(xAxis, yAxis) {
    const { svg } = this.state;

    const axes = svg.select('.axies');

    axes.select('.x.axis')
      .call(xAxis)
      .selectAll('text')
      .attr('transform', 'rotate(25)')
      .style('text-anchor', 'start');

    axes.select('.y.axis')
      .call(yAxis);
  }

  render() {
    return (
      <div className="lineGraphSpace"
        ref={(c) => { this.lineGraphSpace = c; }}
      />
    );
  }
}

export default LineGraph;
